var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeClosedGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.28125 6.11255L19.8813 18.2459",
    stroke: "#ACACAC",
    strokeWidth: 1.73333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9839 13.6662C13.508 14.2753 12.7668 14.6667 11.934 14.6667C10.498 14.6667 9.33398 13.5027 9.33398 12.0667C9.33398 11.4822 9.52684 10.9428 9.8524 10.5085",
    stroke: "#ACACAC",
    strokeWidth: 1.73333
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 6.54311C11.5702 5.52612 14.2972 5.93738 16.1367 7.77688L18.7383 10.3784C19.1687 10.8088 19.3838 11.024 19.5054 11.2524C19.7762 11.7615 19.7762 12.3718 19.5054 12.8809C19.3838 13.1094 19.1687 13.3246 18.7383 13.7549L18.6931 13.8",
    stroke: "#ACACAC",
    strokeWidth: 1.73333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.61403 8.94507C7.95249 8.60661 7.95249 8.05787 7.61403 7.71942C7.27558 7.38096 6.72684 7.38096 6.38838 7.71942L7.61403 8.94507ZM8.16946 15.7436L6.33099 13.905L5.10534 15.1308L6.94381 16.9692L8.16946 15.7436ZM15.5234 15.7436C13.4927 17.7743 10.2002 17.7743 8.16946 15.7436L6.94381 16.9692C9.65146 19.6769 14.0414 19.6769 16.749 16.9692L15.5234 15.7436ZM6.33099 10.2281L7.61403 8.94507L6.38838 7.71942L5.10534 9.00246L6.33099 10.2281ZM16.0472 15.2198L15.5234 15.7436L16.749 16.9692L17.2728 16.4455L16.0472 15.2198ZM6.33099 13.905C5.73589 13.31 5.35251 12.924 5.10718 12.6024C4.87711 12.3009 4.8515 12.1599 4.8515 12.0666H3.11816C3.11816 12.6913 3.38143 13.1981 3.72915 13.6539C4.06159 14.0895 4.54488 14.5703 5.10534 15.1308L6.33099 13.905ZM5.10534 9.00246C4.54488 9.56291 4.06159 10.0436 3.72915 10.4794C3.38143 10.9351 3.11816 11.4419 3.11816 12.0666H4.8515C4.8515 11.9733 4.87711 11.8323 5.10718 11.5307C5.35251 11.2092 5.73589 10.8233 6.33099 10.2281L5.10534 9.00246Z",
    fill: "#ACACAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosedGray);
export default __webpack_public_path__ + "static/media/eye_closed_gray.d4d319d47c198142476635bb9d0ffd8f.svg";
export { ForwardRef as ReactComponent };